import * as React from "react";

import { Grid2 } from "@mui/material";

function FTTestLinks(mode) {
	// console.log("SeriesImageMaker");
	// console.log(mode);
	popupPage();

	function popupPage() {
		//window.open("https://imageservice.dat-vps.com/seriesmaker.html", "_blank");
	}

	return (
		<div id="htmlPage">
			<Grid2 container spacing={2} direction="column">
				{[
					{
						size: "160x600",
						live: "NmpEUMWHe8pF3G",
						staging: "Gpjlc-LOJFbgc-V",
						group: "NE"
					},
					{
						size: "300x250",
						live: "MmpdQNf0ebmd9N",
						staging: "Ggmh35_rYzph3O",
						group: "NE"
					},
					{
						size: "728x90",
						live: "Ggg0NGc_s8j0qN",
						staging: "Gpm_Ox5SuFKpd-l",
						group: "NE"
					},
					{
						size: "300x600",
						live: "qmpknNfHZ8jkoG",
						staging: "Mgmcot_JFKjcow",
						group: "NE"
					},
					{
						size: "970x250",
						live: "NmpQJGfHsKpQ2G",
						staging: "NmmlvFwH2FKmvAn",
						group: "NE"
					},
					{
						size: "300x50",
						live: "GjjMjMc_ebpMgM",
						staging: "qpgW-6GS2AbpD6M",
						group: "NE"
					},
					{
						size: "300x90",
						live: "qgmEDSf_h8pA-0",
						staging: "Mjpw_-q_2YzpHxN",
						group: "NE"
					},
					{
						size: "300x100",
						live: "qjjcVHc_h8gcTS",
						staging: "Mjm_5u7S2AzjOra",
						group: "NE"
					},
					{
						size: "320x50",
						live: "NppkhSWSh8pksS",
						staging: "MmgodG7H2FKm5M7",
						group: "NE"
					},
					{
						size: "320x100",
						live: "Njmn30kSs8mn3H",
						staging: "qmgaj_pQHuYbpSg1",
						group: "NE"
					},
					{
						size: "343x498",
						live: "Mpp7y_W_szgyv0",
						staging: "NmjuTnR0uYKjVo9",
						group: "NE"
					},
					{
						size: "1232x300",
						live: "GpjE__cSh8pESH",
						staging: "GmgpER_JFzgmY1",
						group: "NE"
					},
					{
						size: "306x435",
						live: "MjmC5HkHhKpIO0",
						staging: "GjmxT90uYbgPL1",
						group: "NE"
					},
					{
						size: "728x200",
						live: "MpgJBl8s1zjuBl",
						staging: "Mpm0wJ402Fzgor4",
						group: "NE"
					},
					{
						size: "440x80",
						live: "Mmm-Dof_hKjPxn",
						staging: "qppWAv3SrFbmFa4",
						group: "NE"
					},
					{
						size: "Animated Defaults",
						live: "GjpHAU5AEzpSFU",
						staging: "qpmbjz_JEzmzmz",
						group: "NE"
					},
					{
						size: "Static Defaults",
						live: "qpjLP7dEAbgLxa",
						staging: "NmpgzCf0eKggzB",
						group: "NE"
					},
					{ size: "RCT", live: "#", staging: "GgpfxwaZIKgc-w", group: "RCT" },
					{
						size: "CAT: 160x600",
						live: "NpmAGwf_szjEGo",
						staging: "qpgnKY8n2Ybj8Ez",
						group: "CAT"
					},
					{
						size: "CAT: 300x250",
						live: "Gpm4owWHZbp4tw",
						staging: "qmgGmo2pSuE8poup",
						group: "CAT"
					},
					{
						size: "CAT: 728x90",
						live: "GjmqrtkHZ8gM2t",
						staging: "NpgSNCk0sbp0MB",
						group: "CAT"
					},
					{
						size: "CAT: 300x600",
						live: "NpmQmtWHhzmRjw",
						staging: "qjm3Nj_rAbmUqj",
						group: "CAT"
					},
					{
						size: "CAT: 970x250",
						live: "GgjR-OkSh8g1x5",
						staging: "MjmQJc_JAKp9rc",
						group: "CAT"
					},
					{
						size: "CAT: 320x50",
						live: "Npp_BlW_ebpSIl",
						staging: "NjpShGk02F8jeNc",
						group: "CAT"
					},
					{
						size: "CAT: 300x100",
						live: "Mjm9YOWSZ8j1Fd",
						staging: "Gjm4sW_uFKp6Zf",
						group: "CAT"
					},
					{
						size: "CAT: 320x100",
						live: "MgmXQOc_Z8gXRO",
						staging: "GppMj0pu_rE8j_gu",
						group: "CAT"
					},
					{
						size: "CAT: Defaults",
						live: "qjjUy9lYFKm6yR",
						staging: "Mjpr1YuSJEKj1Ar",
						group: "CAT"
					},
					{
						size: "PHX: 160x600",
						live: "MpmJPJfHe8m2P2",
						staging: "qjpfNj4w2Y8gGp6",
						group: "PHX"
					},
					{
						size: "PHX: 300x250",
						live: "qgpzhuW_ZKj8hu",
						staging: "NmjQwAnJY8m1oE",
						group: "PHX"
					},
					{
						size: "PHX: 300x50",
						live: "qpm842f0hKjz32",
						staging: "NjgUjU5ZtJAKm4Oh",
						group: "PHX"
					},
					{
						size: "PHX: 300x600",
						live: "Nmmf12W_eKjWQ2",
						staging: "NjmfYmBnuFzjAjI",
						group: "PHX"
					},
					{
						size: "PHX: 320x50",
						live: "GgguGrW_hbpuqJ",
						staging: "Gmpqj__CouA8pH_B",
						group: "PHX"
					},
					{
						size: "PHX: 320x100",
						live: "qmmPO2fSh8gDOJ",
						staging: "MjgCpVw2EzpXmL",
						group: "PHX"
					},
					{
						size: "PHX: 728x90",
						live: "qpmIgrWSezgCgr",
						staging: "qpjWMaiorFzmMvi",
						group: "PHX"
					},
					{
						size: "PHX: 970x250",
						live: "MgmLFXm0hKgLEB",
						staging: "NpmkIin2YbpkCV",
						group: "PHX"
					},
					{
						size: "PHX: Defaults",
						live: "Mmp8A95EAzj8E1",
						staging: "Gpp2goztuAbpjob",
						group: "PHX"
					},
					{
						size: "NE TCUV ENG: 160x600",
						live: "GpmV-qW_ZzmVPq",
						staging: "MpjlwvW_h8plwa",
						group: "NE TCUV ENG"
					},
					{
						size: "NE TCUV ENG: 300x250",
						live: "MpjlwvW_h8plwa",
						staging: "NjjSGaf_ezpHM7",
						group: "NE TCUV ENG"
					},
					{
						size: "NE TCUV ENG: 728x90",
						live: "NjjSGaf_ezpHM7",
						staging: "NgmSBvfHeKgSBv",
						group: "NE TCUV ENG"
					},
					{
						size: "NE TCUV ENG: Static Defaults",
						live: "NgmSBvfHeKgSBv",
						staging: "NgmSBvfHeKgSBv",
						group: "NE TCUV ENG"
					},
					{
						size: "NE TCUV ESP: 160x600",
						live: "Gjpqu1f0hzmNr1",
						staging: "NjgvH1kHszgaHQ",
						group: "NE TCUV ESP"
					},
					{
						size: "NE TCUV ESP: 300x250",
						live: "NjgvH1kHszgaHQ",
						staging: "Gmjqv9kSs8jMv9",
						group: "NE TCUV ESP"
					},
					{
						size: "NE TCUV ESP: 728x90",
						live: "Gmjqv9kSs8jMv9",
						staging: "qgj9Dvk_ebgR-v",
						group: "NE TCUV ESP"
					},
					{
						size: "NE TCUV ESP: Static Defaults",
						live: "qgj9Dvk_ebgR-v",
						staging: "qgj9Dvk_ebgR-v",
						group: "NE TCUV ESP"
					}
				].map((ad, index) => (
					<Grid2 item xs={12} key={index}>
						<div>
							<b>{ad.size} </b>-{" "}
							<a
								href={`https://creativepreview.flashtalking.net/pv/${ad.live}`}
								target="_blank"
								rel="noopener noreferrer"
							>
								Live
							</a>{" "}
							-{" "}
							<a
								href={`https://creativepreview.flashtalking.net/pv/${ad.staging}`}
								target="_blank"
								rel="noopener noreferrer"
							>
								Staging
							</a>
						</div>
					</Grid2>
				))}
			</Grid2>
		</div>
	);
}

export default FTTestLinks;
